import { Translations } from "../types/types";

export const translations: Translations = {
  en: {
    nav_link_one: "mission",
    nav_link_two: "work",
    nav_link_three: "contact",
    footer_logo_text:
      "(noun)  / Part of a song recurring between verses  / Group of backing vocalists supporting the lead singer",

    home_text: "Connecting Asian Music and Culture with the World",
    mission_text: [
      "Chorus is a new ecosystem dedicated to uplifting and connecting Asian music and culture with the world. ",
      "Founded by renowned Asian executives, Chorus strives to support Asian artists and their teams to achieve true resonance worldwide. Our mission is to advance the representation and celebration of Asian music from across the continent and diaspora, and elevate its place on the global stage. ",
      "As a growing team of leaders and experts in Asian music, Chorus rallies the unmatched insight, expertise and passion of our alliance towards our collective work: to champion Asian music and culture, and empower Asian artists, teams and labels to participate in the success and development of Asian music around the world. Vice versa, we support artists and teams outside of Asia to build authentic and long-lasting connections with audiences and markets in Asia.",
    ],
    contact_text: [
      "For further enquiries and to request additional details, please email:",
      "info@chorus.asia",
      "Follow us on Instagram and LinkedIn",
    ],
  },
  jp: {
    nav_link_one: "mission",
    nav_link_two: "work",
    nav_link_three: "contact",
    footer_logo_text:
      "(noun)  / Part of a song recurring between verses  / Group of backing vocalists supporting the lead singer",

    home_text: "アジアの音楽と文化を世界と繋ぐ",
    mission_text: [
      "Chorusはアジアの音楽と文化を活気づけ、世界と結び付けることに特化した新たなエコシステム。",
      "数多くの実績で知られ、アジアにルーツを持つメンバーにより設立されたChorusは、アジア系アーティストとそのチームが世界中で真の共感を得るための支援に注力します。私たちのミッションは、彼らが作り出す音楽の表現と祝福を促進させ、世界規模でその地位を高めることです。",
      "アジア音楽界のリーダーや専門家で構成され、規模を拡大させているChorusは、比類ない洞察力、専門知識、情熱をチーム一丸で取り組むプロジェクトに結集させます。それは、アジアの音楽と文化のために闘い、アジア系アーティスト、チーム、レーベルをエンパワーし、世界中でアジア音楽の成功と発展に貢献することです。私たちはまた、アジア圏以外のアーティストやチームがアジアのオーディエンスやマーケットとの本質的かつ長期的な繋がりを築くためのサポートも行います。",
    ],
    contact_text: [
      "お問い合わせやその他詳細をご希望の方は",
      "info@chorus.asiaまでご連絡ください。",

      "Follow us on Instagram and LinkedIn.",
    ],
  },
};
